// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Media Queries */
@media only screen and (min-width: 280px) and (max-width: 482px), only screen and (min-width: 482px) and (max-width: 599px), only screen and (min-width: 482px) and (max-width: 666px), only screen and (min-width: 667px) and (max-width: 900px) {
  #navBar .bg-white {
    background: #fff !important;
    box-shadow: 0px 6px 20px 0 rgba(36, 50, 66, 0.1411764706);
  }
  #navBar .bg-grey {
    background: #fafaf9 !important;
  }
  #navBar .ui.inverted.segment {
    display: block;
    height: 60px !important;
  }
  #navBar .ui.inverted.secondary.menu {
    margin: 0px 30px !important;
    padding: 0px !important;
  }
  #navBar .ui.inverted.secondary.menu .nav-list {
    display: none;
  }
  #navBar .ui.inverted.secondary.menu .grouped-menu .company-logo {
    width: 130px !important;
    margin-left: 10px;
  }
  #navBar .ui.inverted.secondary.menu .grouped-menu .company-logo .navbar-logo {
    width: 130px !important;
    margin: -12px;
  }
  #navBar .icon-menu-list {
    display: block;
    float: right;
    margin-top: -45px;
    margin-right: 15px;
  }
  #navBar .icon-menu-list .contact-us {
    font-size: 12px;
    padding: 10px 15px;
    background: rgb(28, 38, 64);
    color: #fff;
    margin-right: 15px;
    font-family: "Roboto", Roboto !important;
    font-weight: 500;
  }
  #navBar .icon-menu-list .icon {
    font-size: 18px !important;
    margin: auto !important;
    color: #1c2640 !important;
  }
  #navBar .mobile-view {
    display: block;
    margin-top: 60px;
    position: absolute;
    width: 100%;
    z-index: 999;
  }
  #navBar .navBarMobileScreen {
    padding: 10px 30px 10px;
    background: #fff;
    box-shadow: 9px 0px 10px 5px #9e9e9e;
    position: fixed;
    width: 100%;
    margin-left: -1px;
    margin-top: -1px;
    max-height: 92%;
    overflow: scroll;
  }
  #navBar .navBarMobileScreen .item.active .header {
    color: #e85625 !important;
  }
  #navBar .navBarMobileScreen .item.active .item.active .header {
    color: #e85625 !important;
  }
  #navBar .navBarMobileScreen .item.active .item .header {
    color: #1c2640 !important;
  }
  #navBar .navBarMobileScreen .item .content {
    line-height: 2em;
  }
  #navBar .navBarMobileScreen .item .content .icon {
    font-size: 18px !important;
    margin: auto !important;
    color: #1c2640 !important;
    font-weight: 700;
  }
  #navBar .navBarMobileScreen .item .header {
    font-family: "Roboto", Roboto !important;
    font-size: 16px !important;
    font-weight: 500;
    color: #1c2640 !important;
  }
  #navBar .navBarMobileScreen .item .item {
    padding-left: 10px;
  }
  #navBar .navBarMobileScreen .item .item .content {
    line-height: 1.36em !important;
  }
  #navBar .navBarMobileScreen .item .item .header {
    font-size: 14px !important;
    font-weight: 500;
    color: #1c2640 !important;
    margin-bottom: 5px;
  }
  #navBar .navBarMobileScreen .item .item .header .highlight-box {
    font-size: 12px !important;
    font-weight: 300;
  }
  #navBar .flex-menu {
    display: flex !important;
    align-items: baseline;
    gap: 3em;
  }
  #navBar .flex-menu .item {
    width: 50%;
  }
  #navBar .flex-menu.hidden {
    display: none !important;
  }
}
@media only screen and (min-width: 900px) and (max-width: 1023px) {
  #navBar #navBarColor {
    height: 70px !important;
    padding: 5px 15px;
  }
  #navBar .ui.inverted.secondary.menu {
    display: flex;
    margin: 0px 30px !important;
    align-items: center;
    padding: 0px 10px;
  }
  #navBar .ui.inverted.secondary.menu .nav-list {
    min-width: 85px !important;
    font-size: 14px !important;
  }
  #navBar .ui.inverted.secondary.menu .company-logo {
    width: 150px !important;
  }
  #navBar .ui.inverted.secondary.menu .company-logo .navbar-logo {
    width: 150px !important;
  }
  #navBar .ui.inverted.secondary.menu .contact-us {
    float: right !important;
    right: -10px !important;
  }
  #navBar .ui.secondary.inverted.menu .dropdown.item {
    font-size: 14px !important;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1280px) {
  #navBar #navBarColor {
    height: 80px !important;
    padding: 5px 15px;
  }
  #navBar #navBarColor .ui.inverted.secondary.menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 50px !important;
    padding: 0px 10px;
  }
  #navBar #navBarColor .ui.inverted.secondary.menu .nav-list {
    min-width: 85px !important;
  }
  #navBar #navBarColor .ui.inverted.secondary.menu .company-logo {
    width: 150px !important;
  }
  #navBar #navBarColor .ui.inverted.secondary.menu .company-logo .navbar-logo {
    width: 150px !important;
  }
  #navBar #navBarColor .ui.inverted.secondary.menu .contact-us {
    float: right !important;
    right: -10px !important;
  }
}
@media only screen and (min-width: 1024px) and (max-width: 1038px) {
  #navBar .ui.secondary.inverted.menu .dropdown.item {
    padding: 0 !important;
  }
}
@media only screen and (min-width: 901px) and (max-width: 935px) {
  #navBar .ui.secondary.inverted.menu .dropdown.item {
    padding: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/media-queries.scss","webpack://./src/components/NavBar/navBar.scss"],"names":[],"mappings":"AAEA,kBAAA;AAmCI;EChCD;IACC,2BAAA;IACA,yDAAA;EAFF;EAIC;IACC,8BAAA;EAFF;EAKC;IACC,cAAA;IACA,uBAAA;EAHF;EAKC;IACC,2BAAA;IACA,uBAAA;EAHF;EAIE;IACC,aAAA;EAFH;EAKG;IACC,uBAAA;IACA,iBAAA;EAHJ;EAII;IACC,uBAAA;IACA,aAAA;EAFL;EAQC;IACC,cAAA;IACA,YAAA;IACA,iBAAA;IACA,kBAAA;EANF;EAOE;IACC,eAAA;IACA,kBAAA;IACA,2BAAA;IACA,WAAA;IACA,kBAAA;IACA,wCAAA;IACA,gBAAA;EALH;EAOE;IACC,0BAAA;IACA,uBAAA;IACA,yBAAA;EALH;EAQC;IACC,cAAA;IACA,gBAAA;IACA,kBAAA;IACA,WAAA;IACA,YAAA;EANF;EASC;IACC,uBAAA;IACA,gBAAA;IACA,oCAAA;IACA,eAAA;IACG,WAAA;IACA,iBAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;EAPL;EASG;IACC,yBAAA;EAPJ;EAUI;IACC,yBAAA;EARL;EAYI;IACC,yBAAA;EAVL;EAeG;IACC,gBAAA;EAbJ;EAcI;IACC,0BAAA;IACA,uBAAA;IACA,yBAAA;IACA,gBAAA;EAZL;EAeG;IACC,wCAAA;IACA,0BAAA;IACA,gBAAA;IACA,yBAAA;EAbJ;EAeG;IAKC,kBAAA;EAjBJ;EAaI;IACC,8BAAA;EAXL;EAeI;IACC,0BAAA;IACA,gBAAA;IACA,yBAAA;IACA,kBAAA;EAbL;EAcK;IACC,0BAAA;IACA,gBAAA;EAZN;EAkBC;IACC,wBAAA;IACA,qBAAA;IACA,QAAA;EAhBF;EAiBE;IACC,UAAA;EAfH;EAkBC;IACC,wBAAA;EAhBF;AACF;ADhFI;ECmGD;IACC,uBAAA;IACA,iBAAA;EAhBF;EAkBC;IACC,aAAA;IACA,2BAAA;IACA,mBAAA;IACA,iBAAA;EAhBF;EAiBE;IACC,0BAAA;IACA,0BAAA;EAfH;EAiBE;IACC,uBAAA;EAfH;EAgBG;IACC,uBAAA;EAdJ;EAiBE;IACC,uBAAA;IACA,uBAAA;EAfH;EAmBC;IACC,0BAAA;EAjBF;AACF;AD7GI;ECiID;IACC,uBAAA;IACA,iBAAA;EAjBF;EAkBE;IACC,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,yBAAA;IACA,iBAAA;EAhBH;EAiBG;IACC,0BAAA;EAfJ;EAiBG;IACC,uBAAA;EAfJ;EAgBI;IACC,uBAAA;EAdL;EAiBG;IACC,uBAAA;IACA,uBAAA;EAfJ;AACF;AAoBE;EACC;IACC,qBAAA;EAlBF;AACF;AAoBE;EACC;IACC,qBAAA;EAlBF;AACF","sourcesContent":["$size__site_content_width : 1024px;\n\n/* Media Queries */ \n\n$media_queries : (\n    'mobile360'         : unquote(\"only screen and (min-width: 280px) and (max-width: 400px)\"),\n    'xs'                : unquote(\"only screen and (min-width: 280px) and (max-width: 482px)\"),\n    'miniMobile'        : unquote(\"only screen and (min-width: 280px) and (max-width: 450px)\"),\n    'mediumMobile'      : unquote(\"only screen and (min-width: 450px) and (max-width: 482px)\"),\n    'eReaders'          : unquote(\"only screen and (min-width: 482px) and (max-width: 599px)\"),\n    'mobile'            : unquote(\"only screen and (min-width: 482px) and (max-width: 666px)\"),\n    'customMobile'      : unquote(\"only screen and (min-width: 600px) and (max-width: 900px)\"),\n    'miniTab'           : unquote(\"only screen and (min-width: 667px) and (max-width: 900px)\"),\n    'tablet'            : unquote(\"only screen and (min-width: 667px) and (max-width: 1023px)\"),\n    'customTablet'      : unquote(\"only screen and (min-width: 900px) and (max-width: 1023px)\"),\n    'wideTablet'        : unquote(\"only screen and (min-width: 1024px) and (max-width: 1280px)\"),\n    'miniDesktop'       : unquote(\"only screen and (min-width: 1281px) and (max-width: 1482px)\"),\n    'desktop'           : unquote(\"only screen and (min-width: 1025px)\"),\n    'wideScreens'       : unquote(\"only screen and (min-width: 1339px)\"),\n    'hdScreen'          : unquote(\"only screen and (min-width: 1800px)\"),\n    'retina2'           : unquote(\"only screen and (-webkit-min-device-pixel-ratio: 2) and (min-resolution: 192dpi)\"),\n    'retina3'           : unquote(\"only screen and (-webkit-min-device-pixel-ratio: 3) and (min-resolution: 288dpi)\"),\n    'landscape'         : unquote(\"screen and (orientation:landscape)\"),    \n    'portrait'          : unquote(\"screen and (orientation:portrait)\")\n);\n\n@mixin devices($breakpoints) {\n    $conditions : ();\n    @each $breakpoint in $breakpoints {\n        // If the key exists in the map\n        $conditions: append(\n            $conditions,\n            #{inspect(map-get($media_queries, $breakpoint))},\n            comma\n        );\n    }\n\n    @media #{$conditions} {\n        @content;\n    }\n\n}\n","@import '../../media-queries.scss';\n\n// Responsive\n#navBar {\n\t\t@include devices(xs eReaders mobile miniTab) {\n\t\t\t.bg-white {\n\t\t\t\tbackground: #fff !important;\n\t\t\t\tbox-shadow: 0px 6px 20px 0 #24324224;\n\t\t\t}\n\t\t\t.bg-grey {\n\t\t\t\tbackground: #fafaf9 !important;\n\t\t\t}\n\t\t\t// border: none;\n\t\t\t.ui.inverted.segment {\n\t\t\t\tdisplay: block;\n\t\t\t\theight: 60px !important;\n\t\t\t}\n\t\t\t.ui.inverted.secondary.menu {\n\t\t\t\tmargin: 0px 30px !important;\n\t\t\t\tpadding: 0px !important;\n\t\t\t\t.nav-list {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t\t.grouped-menu{\n\t\t\t\t\t.company-logo {\n\t\t\t\t\t\twidth: 130px !important;\n\t\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t\t\t.navbar-logo {\n\t\t\t\t\t\t\twidth: 130px !important;\n\t\t\t\t\t\t\tmargin: -12px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t}\n\t\t\t.icon-menu-list {\n\t\t\t\tdisplay: block;\n\t\t\t\tfloat: right;\n\t\t\t\tmargin-top: -45px;\n\t\t\t\tmargin-right: 15px;\n\t\t\t\t.contact-us {\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tpadding: 10px 15px;\n\t\t\t\t\tbackground: rgb(28, 38, 64);\n\t\t\t\t\tcolor: #fff;\n\t\t\t\t\tmargin-right: 15px;\n\t\t\t\t\tfont-family: 'Roboto', Roboto !important;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t}\n\t\t\t\t.icon {\n\t\t\t\t\tfont-size: 18px !important;\n\t\t\t\t\tmargin: auto !important;\n\t\t\t\t\tcolor: #1c2640 !important;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.mobile-view {\n\t\t\t\tdisplay: block;\n\t\t\t\tmargin-top: 60px;\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 100%;\n\t\t\t\tz-index: 999;\n\t\t\t\t// box-shadow: 2px 2px 4px rgba(0,0,0,0.25);\n\t\t\t}\n\t\t\t.navBarMobileScreen {\n\t\t\t\tpadding: 10px 30px 10px;\n\t\t\t\tbackground: #fff;\n\t\t\t\tbox-shadow: 9px 0px 10px 5px #9e9e9e;\n\t\t\t\tposition: fixed;\n\t\t\t    width: 100%;\n\t\t\t    margin-left: -1px;\n\t\t\t    margin-top: -1px;\n\t\t\t    max-height: 92%;\n    \t\t\toverflow: scroll;\n\t\t\t\t.item.active {\n\t\t\t\t\t.header {\n\t\t\t\t\t\tcolor: #e85625 !important;\n\t\t\t\t\t}\n\t\t\t\t\t.item.active {\n\t\t\t\t\t\t.header {\n\t\t\t\t\t\t\tcolor: #e85625 !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.item {\n\t\t\t\t\t\t.header {\n\t\t\t\t\t\t\tcolor: #1c2640 !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.item {\n\t\t\t\t\t.content {\n\t\t\t\t\t\tline-height: 2em;\n\t\t\t\t\t\t.icon {\n\t\t\t\t\t\t\tfont-size: 18px !important;\n\t\t\t\t\t\t\tmargin: auto !important;\n\t\t\t\t\t\t\tcolor: #1c2640 !important;\n\t\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.header {\n\t\t\t\t\t\tfont-family: 'Roboto', Roboto !important;\n\t\t\t\t\t\tfont-size: 16px !important;\n\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\tcolor: #1c2640 !important;\n\t\t\t\t\t}\n\t\t\t\t\t.item {\n\t\t\t\t\t\t.content {\n\t\t\t\t\t\t\tline-height: 1.36em !important;\n\t\t\t\t\t\t\t// margin-bottom: 5px;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tpadding-left: 10px;\n\t\t\t\t\t\t.header {\n\t\t\t\t\t\t\tfont-size: 14px !important;\n\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\tcolor: #1c2640 !important;\n\t\t\t\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t\t\t\t.highlight-box {\n\t\t\t\t\t\t\t\tfont-size: 12px !important;\n\t\t\t\t\t\t\t\tfont-weight: 300;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.flex-menu{\n\t\t\t\tdisplay: flex !important;\n\t\t\t\talign-items: baseline;\n\t\t\t\tgap: 3em;\n\t\t\t\t.item{\n\t\t\t\t\twidth: 50%;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.flex-menu.hidden{\n\t\t\t\tdisplay: none !important;\n\t\t\t}\n\t\t}\n\t\t@include devices(customTablet) {\n\t\t\t#navBarColor {\n\t\t\t\theight: 70px !important;\n\t\t\t\tpadding: 5px 15px;\n\t\t\t}\n\t\t\t.ui.inverted.secondary.menu {\n\t\t\t\tdisplay: flex;\n\t\t\t\tmargin: 0px 30px !important;\n\t\t\t\talign-items: center;\n\t\t\t\tpadding: 0px 10px;\n\t\t\t\t.nav-list {\n\t\t\t\t\tmin-width: 85px !important;\n\t\t\t\t\tfont-size: 14px !important;\n\t\t\t\t}\n\t\t\t\t.company-logo {\n\t\t\t\t\twidth: 150px !important;\n\t\t\t\t\t.navbar-logo {\n\t\t\t\t\t\twidth: 150px !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.contact-us {\n\t\t\t\t\tfloat: right !important;\n\t\t\t\t\tright: -10px !important;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.ui.secondary.inverted.menu .dropdown.item {\n\t\t\t\tfont-size: 14px !important;\n\t\t\t}\n\t\t}\n\t\t@include devices(wideTablet) {\n\t\t\t#navBarColor {\n\t\t\t\theight: 80px !important;\n\t\t\t\tpadding: 5px 15px;\n\t\t\t\t.ui.inverted.secondary.menu {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: space-between;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tmargin: 0 50px !important;\n\t\t\t\t\tpadding: 0px 10px;\n\t\t\t\t\t.nav-list {\n\t\t\t\t\t\tmin-width: 85px !important;\n\t\t\t\t\t}\n\t\t\t\t\t.company-logo {\n\t\t\t\t\t\twidth: 150px !important;\n\t\t\t\t\t\t.navbar-logo {\n\t\t\t\t\t\t\twidth: 150px !important;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t.contact-us {\n\t\t\t\t\t\tfloat: right !important;\n\t\t\t\t\t\tright: -10px !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t@media only screen and (min-width: 1024px) and (max-width: 1038px) {\n\t\t\t.ui.secondary.inverted.menu .dropdown.item {\n\t\t\t\tpadding: 0 !important;\n\t\t\t}\n\t\t}\n\t\t@media only screen and (min-width: 901px) and (max-width: 935px) {\n\t\t\t.ui.secondary.inverted.menu .dropdown.item {\n\t\t\t\tpadding: 0 !important;\n\t\t\t}\n\t\t}\n\t}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
